import type { ClusterId, ClusterLevelId } from '../../types/ids';
import type { ClusterResult } from '../../types/result';
import { CLUSTER_ICONS } from '../../data/clusterIcons';

interface ClusterCardProps {
  cluster: ClusterResult;
  detailsAction?: 'anchor' | 'modal' | 'hidden';
  onOpenDetails?: (clusterId: ClusterId) => void;
}

/** Ampelfarben-Ton je Cluster-Stufe, nur für die leichte Pill-Einfärbung dieser Card. */
const LEVEL_TONE: Record<ClusterLevelId, 'critical' | 'important' | 'notice'> = {
  very_low: 'critical',
  low: 'critical',
  medium: 'important',
  high: 'notice',
  very_high: 'notice',
};

/** Kompakte Cluster-Card (Abschnitt 16.5): Icon/Titel, Prozentwert, Stufe, Kurzfassung. */
export function ClusterCard({
  cluster,
  detailsAction = 'anchor',
  onOpenDetails,
}: ClusterCardProps) {
  const Icon = CLUSTER_ICONS[cluster.clusterId];

  return (
    <article className="card cluster-card" aria-label={cluster.title}>
      <Icon className="card-icon" aria-hidden="true" />
      <div className="cluster-card__header">
        <h3>{cluster.title}</h3>
        <span className="cluster-card__percentage">{cluster.percentage} %</span>
      </div>
      <p className={`pill pill--tinted pill--${LEVEL_TONE[cluster.level]}`}>{cluster.label}</p>
      <p>{cluster.summary}</p>
      {detailsAction === 'anchor' && (
        <a
          href={`#cluster-detail-${cluster.clusterId}`}
          className="link-action no-print"
          onClick={() => onOpenDetails?.(cluster.clusterId)}
        >
          Details anzeigen
        </a>
      )}
      {detailsAction === 'modal' && (
        <button
          type="button"
          className="link-action no-print"
          onClick={() => onOpenDetails?.(cluster.clusterId)}
        >
          Details anzeigen
        </button>
      )}
    </article>
  );
}
